import { apiService } from '../../lib/services/api-service';
import { AuditLog, AuditLogErrors } from './interfaces';

export const sendAnalytics = async (data: AuditLog) => {
  return apiService.post<AuditLog, any, AuditLogErrors>('/analytics', data);
};
